// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TsgY8nDecv0SrAkThUsg .ji0smSkJa9EAUmgJqIAz{margin-bottom:20px}`, "",{"version":3,"sources":["webpack://./src/app/auth/components/recover-pass-form.component/style.module.scss"],"names":[],"mappings":"AACE,4CACE,kBAAA","sourcesContent":[".recover-pass-form-component {\n  .success-alert {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"recover-pass-form-component": `TsgY8nDecv0SrAkThUsg`,
	"success-alert": `ji0smSkJa9EAUmgJqIAz`
};
export default ___CSS_LOADER_EXPORT___;
